import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { AuthContainer } from 'containers'
import { MainApp } from 'app/MainApp'
import { UnauthenticatedApp } from 'app/UnauthenticatedApp'

export const AppLoader: React.FC = () => {
  const { isAuthenticated } = AuthContainer.useContainer()

  return (
    <div data-testid="app-loader">
      <Router>{isAuthenticated ? <MainApp /> : <UnauthenticatedApp />}</Router>
    </div>
  )
}
